module.exports = __webpack_public_path__ + "b064b5624fda569e9d297901a1810fc9.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Bold.ttf
 ** module id = 904
 ** module chunks = 9
 **/